import script from "./Inpaint.vue?vue&type=script&setup=true&lang=ts"
export * from "./Inpaint.vue?vue&type=script&setup=true&lang=ts"

import "./Inpaint.scss?vue&type=style&index=0&id=2503199f&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2503199f"]])

export default __exports__